import { heroStats } from '@/pages/home/data';

export default function HeroSection() {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-gradient-to-b from-background-100 via-background-50 to-background-50"
    >
      <div className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-accent-100/50 blur-3xl pointer-events-none"></div>
      <div className="absolute top-40 -left-20 w-[320px] h-[320px] rounded-full bg-primary-100/50 blur-3xl pointer-events-none"></div>

      <div className="relative max-w-[1240px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center">
          <div className="animate-float-up">
            <span className="inline-flex items-center gap-2 h-8 px-3 rounded-full bg-accent-100 text-accent-900 text-xs font-medium">
              <i className="ri-fire-line"></i>
              2026 最新版本 v5.8.2 已上线
            </span>

            <h1 className="mt-5 font-heading font-bold text-3xl md:text-5xl leading-tight text-foreground-950">
              蘑菇视频 APP 下载
              <span className="text-primary-600">安装指南</span>
            </h1>

            <p className="mt-5 text-base md:text-lg leading-relaxed text-foreground-600 max-w-xl">
              安卓版下载、手机版安装包与最新版本获取方式，一次讲清楚。找不到安装入口不用慌，
              按照页面里的步骤操作，就能轻松完成安装。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-2-line text-lg"></i>
                下载安卓版安装包
              </a>
              <a
                href="#steps"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-background-300 bg-background-50 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-book-open-line text-lg"></i>
                查看图文安装教程
              </a>
            </div>

            <dl className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-5 border-t border-background-200 pt-6">
              {heroStats.map((item) => (
                <div key={item.label}>
                  <dt className="text-xs text-foreground-400">{item.label}</dt>
                  <dd className="mt-1 font-heading font-bold text-lg text-foreground-900">{item.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="animate-fade-in delay-200">
            <div className="relative mx-auto w-full max-w-[420px]">
              <div className="absolute -inset-3 rounded-2xl bg-gradient-to-tr from-primary-100 via-accent-100 to-secondary-100 rotate-2"></div>
              <div className="relative w-full aspect-[9/11] rounded-2xl overflow-hidden border border-background-200 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20standing%20upright%20on%20a%20warm%20cream%20studio%20backdrop%20displaying%20a%20colorful%20video%20streaming%20app%20interface%2C%20soft%20natural%20side%20lighting%2C%20warm%20orange%20and%20amber%20tones%2C%20minimalist%20editorial%20product%20photography%2C%20clean%20composition%2C%20high%20detail&width=900&height=1100&seq=mushroom-hero-01&orientation=portrait"
                  alt="蘑菇视频手机端界面预览"
                  title="蘑菇视频手机端界面预览 安卓版下载"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="absolute -bottom-5 -left-4 md:-left-8 bg-background-50 border border-background-200 rounded-xl px-4 py-3 flex items-center gap-3">
                <span className="w-10 h-10 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center">
                  <i className="ri-checkbox-circle-line text-xl"></i>
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-900">安装包已校验</p>
                  <p className="text-xs text-foreground-500">安全完整 · 无捆绑</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}